export default function Maintenance() {
  return (
    <div className="container text-black m-auto text-center bg-[#edd113] rounded-3xl uppercase">
      <div className="text-[80px]">Under</div>
      <div className="text-[64px]">Maintenance</div>
    </div>
  )
}
